var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"id":"row","justify":"center","align":"center"}},[_c('img',{attrs:{"alt":"Logo","src":_vm.logoPath}})])}
var staticRenderFns = []

export { render, staticRenderFns }